import { useEffect } from "react";
import Confirm from "components/popup/ConfirmActionPopup.component";
import UserCommentArea from "components/workflows/UserCommentArea.component";
import translate from "components/translations/translations.wrapper";
import { DOCUMENT_TYPE, MODAL_ACTIONS, MODAL_SEVERITY } from "utils/constants";
import { ActivateWorkflowPopupProps } from "types/activateWorkflowPopup";
import { launchDarkly } from "utils/launchDarkly";
import { useModalContext } from "components/modals/ModalContext";

export function ActivateWorkflowPopup(props: ActivateWorkflowPopupProps) {
    const useNewModals = launchDarkly.companyClient?.variation("use-new-modals", false);
    const modalContext = useModalContext();
    const toggleModal = modalContext?.toggleModal;

    const computeActivateMessage = function() {
        if(props.activate && props.replaceActiveRuleName)
            return props.translate("workflowDetails.confirmDialog.activateMessageReplace", props.ruleName, props.replaceActiveRuleName);
        if(props.activate)
            return props.translate("workflowDetails.confirmDialog.activateMessage", props.translate("documentTypes." + DOCUMENT_TYPE.asString(props.documentType)));
        else
            return props.translate("workflowDetails.confirmDialog.deactivateMessage", props.translate("documentTypes." + DOCUMENT_TYPE.asString(props.documentType)))
    }

    useEffect(() => {
        if (useNewModals && toggleModal) {
            toggleModal(MODAL_ACTIONS.CONFIRM_ACTION, {
                title: props.activate
                    ? props.translate("workflowDetails.confirmDialog.activateTitle", props.ruleName)
                    : props.translate("workflowDetails.confirmDialog.deactivateTitle", props.ruleName),
                description: computeActivateMessage(),
                confirmButtonText: "popUp.yes",
                cancelButtonText: "popUp.no",
                severity: MODAL_SEVERITY.INFORMATION,
                handleAction: () => {
                    toggleModal(null);
                    props.onActivate();
                },
                closeCallback: () => props.onCancel(),
                moreContent: (
                    <UserCommentArea
                        inputMessage={props.translate("workflowDetails.confirmDialog.describeChanges")}
                        moreInfo={props.translate("workflowDetails.confirmDialog.moreInfo")}
                        userInput={props.activateUserInputRef}
                    />
                ),
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: open once on mount
    }, []);

    if (useNewModals && toggleModal) {
        return null;
    }

    return (
        <Confirm translate={props.translate}
                 handleAction={props.onActivate}
                 closeCallback={() => {
                     props.onCancel();
                 }}
                 modalType={"modal-warning"}
                 confirmButtonText={props.activate ? props.translate("workflowDetails.confirmDialog.activateWorkflow")
                     : props.translate("workflowDetails.confirmDialog.deactivateWorkflow")}
                 cancelButtonText={props.translate("workflowDetails.confirmDialog.cancelActivate")}
                 title={props.activate ? props.translate("workflowDetails.confirmDialog.activateTitle", props.ruleName)
                     : props.translate("workflowDetails.confirmDialog.deactivateTitle", props.ruleName)}
                 moreContent={<UserCommentArea
                     message={computeActivateMessage()}
                     inputMessage={props.translate("workflowDetails.confirmDialog.describeChanges")}
                     moreInfo={props.translate("workflowDetails.confirmDialog.moreInfo")}
                     userInput={props.activateUserInputRef}
                 />}
        >
        </Confirm>
    );
}

const withTranslations = translate(ActivateWorkflowPopup);
export default withTranslations;